<template>
  <div>
    <div id="container" />
    <el-pagination class="page"
      background
      layout="total, prev, pager, next"
      :page-count="total"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import { Chart } from '@antv/g2';
  import Global from "./Global";

  export default {
    name: "usetime",
    data() {
      return {
        total: 20,
        chart: null
      };
    },
    mounted() {
      this.chart = new Chart({
              container: 'container',
              autoFit: true,
              height: 680,
              padding: [0, 70],
            });
      this.initLineChart(1, this.chart)
    },
    methods: {
      handleCurrentChange(val) {
        this.updateChart(val, this.chart);
      },
      initLineChart(pageNum, chart) {
        this.updateData(pageNum, chart);
      },
      updateChart(pageNum, chart) {
        chart.clear();
        this.updateData(pageNum, chart);
      },
      updateData(pageNum, chart) {
        let that = this;
        fetch(
          Global.accountUrl + "/storkCollectData/selectAllUserUseTimeByPage?pageNum="+pageNum+"&pageSize=10")
          .then(res => res.json())
          .then(data => {
            that.total = data.data.total;
            chart.data(data.data.data);
            chart.scale({
              value: {
                max: 100,
                min: 0,
                alias: '时间（分钟）',
              },
            });
            chart.axis('username', {
              title: null,
              tickLine: null,
              label: {
                formatter: (val) => {
                  let str = val + '';
                  return str.substring(0, 3) + '**' + str.substring(str.length - 4);
                }
              }
            });
            chart.axis('usetime', {
              label: null,
              title: {
                offset: 30,
                style: {
                  fontSize: 12,
                  fontWeight: 300,
                },
              },
            });
            chart.legend(false);
            chart.coordinate().transpose();
            chart.tooltip({
              itemTpl: `
                              <ul style="margin: 10px">
                                <li style = "padding: 10px 0">用户昵称：{nickname}</li>
                                <li>使用时长：{usetime}分钟</li>
                              </ul>
                             `,
            });
            chart
              .interval({
                sortable: true
              })
              .position('username*usetime')
              .size(26)
              .tooltip({
                fields: ['nickname', 'usetime'],
                callback: (nickname, usetime) => {
                  return {
                    nickname,
                    usetime
                  }
                }
              })
              .label('usetime',
                (xValue) => {
                  return {
                    content: xValue + '分钟',
                  };
                },
                {
                  type: 'base',
                }
              );
            chart.on('element:click', e => {
              let element = e.target.get("element");
              let data = element.getModel().data;
              that.toLocation(data.username);
            });
            chart.interaction('element-active');
            chart.render();
          });
      },
      toLocation(username) {
        this.$emit('getLocation', username);
      }
    }
  };
</script>

<style>
  .page {
    width: 400px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/UseTime.vue